import { Preferences } from "../../profile/objects/preferences";
import { Column } from "../objects/column";
import { ListPreferenceResult, setListPreference } from "../../utils/list/utils/setListPreference";
import { ACCOUNT_NEWSPAPER_MODULE, NEWSPAPER_COLUMN } from "../constants/accountSettingsConstants";

export const setNewspaperPreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: ACCOUNT_NEWSPAPER_MODULE,
        default_columns: NEWSPAPER_COLUMN,
        default_order_by: '',
        default_order: 'asc',
    });
